/* eslint-disable import/no-cycle */
import { notifications } from '@mantine/notifications';
import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '@stores/index';

type AsyncThunkConfig = {
  state: RootState;
  dispatch: AppDispatch;
};

const withMessageForError =
  <Returned, Args = void, ThunkApiConfig extends AsyncThunkConfig = AsyncThunkConfig>(
    payloadCreator: AsyncThunkPayloadCreator<Returned, Args, ThunkApiConfig>
  ) =>
  async (args: Args, thunkAPI: any) => {
    try {
      return await payloadCreator(args, thunkAPI);
    } catch (err: any) {
      notifications.show({
        message: err?.response?.data?.message || 'خطا!',
        color: 'danger',
      });
      throw err;
    }
  };

const createAppAsyncThunk = createAsyncThunk.withTypes<AsyncThunkConfig>();

export { createAppAsyncThunk, withMessageForError };
